import { Stack } from '@mantine/core';

import type { StackProps } from '@mantine/core';
import type { ReactNode } from 'react';

type ModalContentProps = StackProps & { children?: ReactNode };

export const ModalContent = ({ children, style, ...props }: ModalContentProps) => (
  <Stack gap='md' p='md' style={{ overflowY: 'auto', flex: 1, minHeight: 0, ...style }} {...props}>
    {children}
  </Stack>
);
